import * as React from "react";
import { cn } from "@/lib/utils";

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        "bg-muted animate-pulse rounded-[14px] duration-[1300ms] ease-linear motion-reduce:animate-none",
        className,
      )}
      {...props}
    />
  );
}

export { Skeleton };
